<template>
  <v-dialog v-model="dialog" width="600px">
    <v-card>
      <v-card-title class="white--text primary"
        >NỘI DUNG HỌC
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-divider></v-divider>
      <v-form ref="form" class="pa-6">
        <v-text-field
          label="Tiết theo PPCT"
          v-model="lessonIndex"
          dense
          outlined
          class="required"
          :rules="[$rules.required, $rules.integer]"
        ></v-text-field>
        <v-textarea
          v-model="lesson"
          class="required"
          :rules="[$rules.required]"
          label="Nội dung học"
          hide-details="auto"
          outlined
        ></v-textarea>
      </v-form>

      <v-divider></v-divider>
      <v-row class="px-6 pb-6 mt-6" no-gutters>
        <v-btn class="px-6" outlined light depressed @click="cancel">Hủy</v-btn>
        <v-spacer></v-spacer>
        <v-btn class="px-6" depressed color="primary" @click="save">Lưu</v-btn>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { get } from 'lodash'

export default {
  components: {},
  props: {
    state: Boolean,
    lessonProp: String,
    lessonIndexProp: String
  },
  data() {
    return {
      dialog: false,
      loading: false,
      lesson: get(this.slot, 'classNote.lesson', ''),
      lessonIndex: get(this.slot, 'classNote.data.lessonIndex', '')
    }
  },
  computed: {
    ...mapState('ClassNoteDetail', ['slot']),
    ...mapGetters('ClassNoteDetail', ['classNoteDetailData'])
  },

  methods: {
    ...mapActions('ClassNoteDetail', ['updateLesson']),
    async save() {
      if (!this.$refs.form.validate()) return
      this.$loading.active = true
      try {
        const data = {
          lesson: this.lesson,
          data: {
            lessonIndex: this.lessonIndex
          },
          ...this.classNoteDetailData
        }

        await this.updateLesson(data)
        this.dialog = false

        this.$alert.updateSuccess()
      } catch (error) {
        console.error(error)
        this.$alert.updateError(error)
      } finally {
        this.$loading.active = false
      }
    },
    cancel() {
      this.dialog = false
    }
  },
  watch: {
    state(state) {
      this.dialog = true
    },
    lessonProp: {
      handler(val) {
        this.lesson = val || ''
      },
      immediate: true
    },
    lessonIndexProp: {
      handler(val) {
        this.lessonIndex = val || ''
      },
      immediate: true
    }
  }
}
</script>
